import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/nj-laptop.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#262032" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              TekRevol’s Website Design Experts Building Feature-Rich Web
              Solutions
            </h2>
            <p>
              Tekrevol houses a team of expert website developers, designers,
              and product engineers, making it inherently capable of taking on
              any website development project and making it a success
              irrespective of its complexity. We offer website design and
              development services across diverse industries, ranging from
              e-commerce to real estate, hospitals to educational organizations,
              and so on. Whichever sector we serve, our created websites are
              masterpieces because of our core focus on user experience,
              functionality, and performance.Moreover, our result-driven
              methodologies and success-oriented approach have made us the best
              web design and development company in New Jersey.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#262032",
                border: "1px solid #262032",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
